module.exports = __webpack_public_path__ + "img/INF-B-2-III.04e0250e.png";